import { useEffect } from "react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../lib/api";

export function ViewAsBanner() {
  const { user } = useAuth();
  const impersonating = !!user?._impersonating;

  useEffect(() => {
    if (!impersonating) return;
    const interval = setInterval(() => {
      toast.warning(`Reminder: You're still viewing as ${user.display_name} (${user.role}) — click the top banner to exit.`, { duration: 8000, id: "view-as-reminder" });
    }, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [impersonating, user?.display_name, user?.role]);

  if (!impersonating) return null;

  const exit = async () => {
    const exitPath = user?._impersonator_role === "manager" ? "/manager/view-as/exit" : "/admin/view-as/exit";
    const homePath = user?._impersonator_role === "manager" ? "/manager" : "/admin";
    try {
      await api.post(exitPath);
    } finally {
      window.location.href = homePath;
    }
  };

  return (
    <button
      data-testid="view-as-banner"
      onClick={exit}
      title="You're currently viewing the portal as this user to see exactly what they see. Click anywhere on this bar to exit and return to your own account."
      className="fixed top-0 left-0 right-0 h-9 z-[300] bg-igc-gold text-black text-xs font-medium flex items-center justify-center gap-2 hover:bg-igc-goldHover transition-colors animate-pulse"
    >
      Viewing as {user.display_name} ({user.role}) — Click to Exit
    </button>
  );
}
